/**
 * ⚙️ Settings Component
 */

import React from 'react';

const Settings = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-dark-secondary shadow rounded-lg p-6 border dark:border-dark-copper-dark">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          ⚙️ Einstellungen
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          System-Einstellungen werden hier implementiert.
        </p>
      </div>
    </div>
  );
};

export default Settings;
